import { Viewer } from "cesium";
import { DialogGeneral } from "../../../utils/Dialog/dialog";
import { createUUID } from "../../../utils/utils";
import { IconMinus, IconPlus } from "../../../icon";
import { getMessage } from "../../../language";
export interface ICustomGroup {
    key: string;
    value?: string;
    isDefault?: boolean;
}
export class FormFilterTreeLayer {
    viewer: Viewer;
    containerId: string;
    private _generateId = createUUID();
    dialog: DialogGeneral | undefined;
    private onClosedCallback: ((status: boolean, data: any) => void) | undefined; // Callback khi đóng modal
    constructor(viewer: Viewer, containerId: string) {
        this.containerId = containerId;  // Gán giá trị containerId    
        this.viewer = viewer;  // Gán giá trị viewer  

        this.createModalDialog();
        this.dialog?.showModal(true)
        this._attachFooterButtonEvents();
    }

    //#region createModalDialog
    createModalDialog = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage('filter-title-layer-model');
        this.dialog.isModal = true
        this.dialog.minimizeDialog = true;
        this.dialog.zIndex = 1000;
        this.dialog.topModal = "50%"
        this.dialog.leftModal = "50%"
        this.dialog.widthModal = '250px'

        this.dialog.minHeightModal = 160
        this.dialog.firstLoad = false
        // Lấy chuỗi HTML của tree view và gán cho innerBody
        this.dialog.innerBody = this.renderBodyModal();
        this.dialog.innerFooter = this.renderFooter();

        this.dialog.createDialog();

        // Thêm input ảo mặc định lúc đầu
        this._appendFakeInput();
    }
    //#region handleCloseModal
    private handleCloseModal = (status: boolean) => {
        if (!status) {
            const inputRow = document.getElementById(`input-row-${this._generateId}`)!;
            const inputs = inputRow.querySelectorAll('input');
            if (inputs.length === 1 && this._storageCustomGroups.length === 0) {
                // Nếu chỉ còn input ảo và không có nhóm nào được lưu, thì không làm gì cả
                this.notifyCallBack(false, { action: "closeFilter" }); // Gọi callback với kết quả

            } else {

                this.notifyCallBack(status, undefined); // Gọi callback với kết quả
            }
        }
        this.dialog?.showModal(false)

    }
    //#region setClosedCallback
    setClosedCallback(callback: (status: boolean, data: any) => void): void {
        this.onClosedCallback = callback;
    }
    //#region notifyCallBack
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean, data: any): void {
        if (this.onClosedCallback) {

            this.onClosedCallback(status, data); // Thông báo cho lớp cha

        }

        this.showHideModel(false)

    }

    showHideModel = (show: boolean) => {
        if (this.dialog) {
            if (show) {
                this._renderInputsFromStorage();
            }

            this.dialog.showModal(show);
        }
    }


    //#region renderBodyModal
    private containerBody: HTMLDivElement | undefined
    private renderBodyModal = (): HTMLElement => {
        if (this.containerBody) {
            this.clearContainer()
        } else {
            this.containerBody = document.createElement('div')
            this.containerBody.className = 'container-form-label-point'

        }

        this.createForm()
        return this.containerBody
    }
    //#region renderFooter
    private containerFooter: HTMLDivElement | undefined
    private renderFooter = (): HTMLElement => {
        this.containerFooter = document.createElement('div')
        this.containerFooter.style.cssText = 'width: 100%;display: flex; justify-content: space-between; align-items: center;padding: 5px 5px 0 5px;'
        this.containerFooter.innerHTML = `         
        <div style="display: flex; gap: 5px;">
        <button id="add-filter-btn-${this._generateId}" class="DPU-btn-defaut-style disable" disabled>${IconPlus()}</button>
        <button id="remove-filter-btn-${this._generateId}" class="DPU-btn-defaut-style disable" disabled>${IconMinus()}</button>
        </div>
        <button id="btn-create-${this.containerId}" class="btn-ok-modal">OK</button>       
     `
        // Gán sự kiện riêng cho các nút không thuộc nhóm
        const btnOk = this.containerFooter.querySelector(`#btn-create-${this.containerId}`);
        if (btnOk) {
            btnOk.addEventListener('click', () => this.handleExportInputValues());
        }

        return this.containerFooter
    }
    //#region clearContainer
    private clearContainer = () => {
        if (this.containerBody) {
            this.containerBody.innerHTML = '';
        }
    };

    //#region _attachFooterButtonEvents
    private _attachFooterButtonEvents = () => {
        document.getElementById(`add-filter-btn-${this._generateId}`)!.addEventListener("click", () => {
            this.handleAddInputRow();
        });
        document.getElementById(`remove-filter-btn-${this._generateId}`)!.addEventListener("click", () => {
            this.handleRemoveInputRow();
        });
    }

    //#region createForm
    createForm = () => {
        this.containerBody!.innerHTML = `
    <div id="input-row-${this._generateId}" style="display: grid; grid-template-columns: 1fr;">
    </div>
 
  `;
        //   <input type="text"  class="input-form-label dpu-input-text"  placeholder="Key" />


    }

    //#region _appendFakeInput
    private _toggleAddButton = false
    private _fakeInput: HTMLInputElement | undefined;
    private _appendFakeInput = () => {
        const inputRow = document.getElementById(`input-row-${this._generateId}`)!;

        this._fakeInput = document.createElement("input");
        this._fakeInput.type = "text";
        this._fakeInput.className = "input-form-label dpu-input-text fake-input";
        this._fakeInput.placeholder = "Key";

        // Gán onchange để khi gõ gì vào thì add input
        this._fakeInput.addEventListener("input", (e: any) => {
            if (e.target.value !== "") {
                if (this._toggleAddButton) return; // Nếu đã toggle thì không làm gì nữa
                this._stateButtonAdd(true)
                this._toggleAddButton = true; // Đánh dấu đã toggle

            } else {
                this._stateButtonAdd(false)
                this._toggleAddButton = false; // Đánh dấu đã toggle
            }
        });

        inputRow.appendChild(this._fakeInput);
    }

    //#region handleAddInputRow
    private handleAddInputRow = () => {
        const inputRow = document.getElementById(`input-row-${this._generateId}`)!;

        // Tạo input mới
        const inputKey = document.createElement('input');
        inputKey.type = 'text';
        inputKey.className = 'input-form-label dpu-input-text';
        inputKey.placeholder = 'Key';
        inputKey.value = this._fakeInput!.value.trim(); // Lấy giá trị từ input ảo
        // Disable input mới tạo
        inputKey.disabled = true;
        inputKey.classList.add('disable');

        // Thêm vào trước input ảo
        inputRow.insertBefore(inputKey, this._fakeInput!);

        // Reset fake input value và trạng thái nút
        this._fakeInput!.value = '';
        this._stateButtonAdd(false);
        this._toggleAddButton = false;
        this._stateButtonRemove(true); // Hiển thị nút remove nếu có ít nhất 1 input
    };
    //#region handleRemoveInputRow
    private handleRemoveInputRow = () => {
        const inputRow = document.getElementById(`input-row-${this._generateId}`)!;
        const inputs = inputRow.querySelectorAll('input');

        if (inputs.length > 1) {
            const prevInput = this._fakeInput?.previousElementSibling as HTMLInputElement;

            if (prevInput) {
                this._fakeInput!.value = prevInput.value; // Lấy giá trị từ input trước input ảo
                inputRow.removeChild(prevInput);
                this._stateButtonAdd(true);
                this._toggleAddButton = true;
            }


        } else if (inputs.length === 1) {
            // Chỉ còn input ảo, clear và enable nó lại
            this._fakeInput!.value = '';
            this._stateButtonRemove(false); // Hiển thị nút remove nếu có ít nhất 1 input
            this._stateButtonAdd(false);
            this._toggleAddButton = false; // Reset trạng thái toggle

        }
    };

    private _storageCustomGroups: ICustomGroup[] = [];
    //#region handleExportInputValues
    private handleExportInputValues = () => {
        const inputRow = document.getElementById(`input-row-${this._generateId}`)!;
        const inputs = inputRow.querySelectorAll('input');

        this._storageCustomGroups = [];

        inputs.forEach((input) => {
            const key = input.value.trim();
            if (key !== '') {
                this._storageCustomGroups.push({
                    key,
                    value: "", // Không cần value trong trường hợp này
                    isDefault: key === '_' ? true : false
                });
            }
        });
        this._stateButtonAdd(false)
        this._toggleAddButton = false; // Đánh dấu đã toggle
        this.notifyCallBack(true, this._storageCustomGroups);
    }



    //#region _renderInputsFromStorage

    private _renderInputsFromStorage = () => {
        const inputRow = document.getElementById(`input-row-${this._generateId}`)!;
        inputRow.innerHTML = ''; // clear hết

        if (this._storageCustomGroups.length > 0) {
            this._storageCustomGroups.forEach((item, index) => {
                const inputKey = document.createElement('input');
                inputKey.type = 'text';
                inputKey.className = 'input-form-label dpu-input-text';
                inputKey.placeholder = 'Key';
                inputKey.value = item.key;

                // Disable hết trừ cái cuối cùng
                inputKey.disabled = true;
                inputKey.classList.add('disable');

                inputRow.appendChild(inputKey);
            });
            this._appendFakeInput();
            this._stateButtonRemove(true); // Hiển thị nút remove nếu có ít nhất 1 input

        } else {
            this._appendFakeInput();
        }

    };
    //#region _stateButtonAdd
    private _stateButtonAdd = (isShow: boolean) => {
        const btnAdd = document.getElementById(`add-filter-btn-${this._generateId}`) as HTMLButtonElement;
        if (isShow && btnAdd) {
            btnAdd.classList.remove('disable');
            btnAdd.disabled = false;
        } else {
            if (btnAdd) {
                btnAdd.classList.add('disable');
                btnAdd.disabled = true;
            }
        }

    }
    //#region _stateButtonRemove
    private _stateButtonRemove = (isShow: boolean) => {
        const btnRemove = document.getElementById(`remove-filter-btn-${this._generateId}`) as HTMLButtonElement;
        if (isShow && btnRemove) {
            btnRemove.classList.remove('disable');
            btnRemove.disabled = false;
        } else {

            btnRemove.classList.add('disable');
            btnRemove.disabled = true;

        }

    }
}